{
  "gmSpeedMult": 5,
  "gmLook": {
    "tier": 5,
    "plus": 10,
    "cape": "cloak_of_the_paragon"
  },
  "defaultBanHours": 24,
  "defaultMuteMinutes": 10,
  "spawnMax": 20,
  "chatSpam": {
    "globalIntervalMs": 3000,
    "burstMax": 5,
    "burstWindowMs": 15000,
    "repeatWindowMs": 30000,
    "strikesToMute": 5,
    "strikeWindowMs": 60000,
    "muteMs": 60000
  }
}
